var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRentgologo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 262 50",
    style: {
      enableBackground: "new 0 0 262 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#293787;}\n\t.st1{fill:#FF0000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.3,26.5h-1.8l-6.7,17.5c-0.8,2.1-1.1,3.8-1,5.3H70.2c0.9-1.6,1.8-3.4,2.6-5.4L86.9,6.8 c0.5-1.4,1.1-3.5,1.6-6.2h18.1c3.1,0,5.1,0.5,5.9,1.4c0.9,0.9,0.8,2.5,0,4.8l-4.2,10.9c-0.8,2-1.9,3.4-3.4,4.4 c-1.3,0.8-3.1,1.4-5.5,2c2,0.4,3.4,0.9,4.1,1.5c0.8,0.9,0.9,2.2,0.2,4L98,44.4c-0.6,1.5-0.9,3.1-0.8,5H86l7.2-18.9 C94.3,27.9,93.6,26.5,91.3,26.5z M100.2,5.3h-2.6l-6.4,16.8h1.9c2.2,0,3.9-1.3,4.9-4l3.8-9.9C102.6,6.3,102,5.3,100.2,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M133.4,31.2h-14.2l-4.8,12.4c-0.6,1.6-0.1,2.4,1.6,2.4c1.6,0,2.7-0.8,3.4-2.5l3.3-8.5h9.2l-3.3,8.4 c-1.1,2.7-2.5,4.5-4.4,5.4c-1.9,0.8-5.4,1.3-10.6,1.3c-4.7,0-7.7-0.5-8.8-1.5c-1.1-0.8-1.1-2.6-0.1-5.2l9.4-24.4 c1.2-3,3.2-4.9,6.3-5.7c1.3-0.3,3.9-0.5,8-0.5c5,0,8.1,0.3,9.3,0.9c1.3,0.7,1.5,2.4,0.5,5L133.4,31.2z M120.5,27.9h4.9l3.6-9.3 c0.5-1.3,0-2-1.6-2c-1.7,0-2.8,0.7-3.3,2.1L120.5,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163,12.8c2.4,0,4.1,0.5,5.1,1.4c1,1,1.1,2.3,0.5,3.9l-11.1,28.2c-0.5,1.2-0.7,2.2-0.7,3h-10.1l11.8-30.1 c0.6-1.6,0.2-2.4-1.3-2.4c-1.5,0-2.5,0.8-3.2,2.4l-10.6,27.1c-0.5,1.2-0.7,2.2-0.7,3h-10.4c0.6-0.9,1.1-1.9,1.5-3l11.4-29.3 c0.5-1.3,0.9-2.6,1-3.7h8.6l0.6,1.2C158.3,13.4,160.8,12.8,163,12.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.1,49.7c-3.4,0-5.6-0.3-6.7-1c-1.4-0.9-1.6-2.6-0.6-5.2l10.5-26.5h-3l1.4-3.5h3l2.6-6.6l10.2-1.6 l-3.2,8.2h5.1l-1.4,3.5h-5L176.4,41c-0.7,1.9-1,3.1-0.8,3.8c0.2,0.7,1,1,2.3,1h2.8l-1.3,3.4C176.7,49.5,174.6,49.7,173.1,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216.4,23.4h13l-10.5,26c-3.1,0.4-7.5,0.6-13.1,0.6c-5.4,0-8.7-0.4-9.9-1.3c-1.2-0.9-1.2-2.9,0.1-5.9 l14.5-36.4c1.1-2.7,2.8-4.4,5.1-5.3c2-0.7,5.5-1,10.6-1c6.3,0,10.4,0.2,12.2,0.5c-0.4,0.6-1.3,2.6-2.7,6.1l-4.6,11.5h-9l4.4-11 c0.4-1.1,0.5-1.8,0.2-2.1c-0.3-0.3-1-0.5-2.1-0.5c-1.2,0-2.1,0.2-2.7,0.6c-0.6,0.4-1.1,1.1-1.6,2.2l-14.1,35.1 c-0.8,2-0.3,3.1,1.5,3.1c1.7,0,3-1,3.8-3l5.8-14.3h-2.7L216.4,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.6,43.6l10.2-25.1c1.1-2.7,3.2-4.5,6.3-5.2c1.3-0.3,4-0.5,8-0.5c4.5,0,7.3,0.4,8.4,1.1 c1.2,0.7,1.2,2.3,0.2,4.9l-10,24.6c-1.1,2.7-2.4,4.4-4.1,5.2c-1.8,0.9-5.2,1.4-10.2,1.4c-4.8,0-7.7-0.4-8.7-1.3 C226.6,47.9,226.6,46.2,227.6,43.6z M250,16.6c-1.6,0-2.7,0.8-3.3,2.4l-9.9,24.4c-0.7,1.6-0.2,2.4,1.4,2.4c1.6,0,2.7-0.8,3.3-2.4 l9.9-24.4C252.1,17.4,251.6,16.6,250,16.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.3,10.4 71.2,0.6 83.8,0.6 80,10.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "50.8,20.2 54.7,10.4 67.3,10.4 63.5,20.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.4,30 38.3,20.2 50.8,20.2 47,30  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.7,49.5 30.6,39.8 43.1,39.8 39.3,49.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "59.6,30 63.5,20.2 76.1,20.2 72.3,30  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "42.1,10.4 46,0.6 58.6,0.6 54.7,10.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "43.1,39.8 47,30 59.6,30 55.8,39.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25.6,20.2 29.5,10.4 42.1,10.4 38.3,20.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0.6,20.2 4.5,10.4 17.1,10.4 13.2,20.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "5.7,39.8 9.6,30 22.1,30 18.3,39.8  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentgologo);
export default __webpack_public_path__ + "static/media/rentgologo.2016f8894306399060ef7cdd7c17b2ff.svg";
export { ForwardRef as ReactComponent };